import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getPostsSectionInitActions(responseData, requestParams) {
  return [
    getSectionLayoutInitAction(responseData, 'posts'),
    ...getAllModulesInitActions(responseData, requestParams),
  ].filter(action => action);
}
